/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import MenuScreen from '@components/screen/MenuScreen';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTable from '@components/sociolla/SociollaTable';
import Image from '@components/global/Image';
import ModalDetailProduct from '@components/transaction/catalog/ModalDetailProduct';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { backSection, backSectionText } from '@/assets/styles/mainStyles';
import { getProductsFromEs, getProductsCountFromEs } from '@api/ms-b2b';
import tableApi from '@/hooks/tableApi';
import { MsCatalog } from '@api/ms-catalog';
import { setProductData } from '@/store/product';
import { paramsReseted } from '@/store/params';

const HEADER = [
  {
    label: 'Name',
    data: 'name',
    width: '100%',
  },
];

const HEADER_DEKSTOP = [
  {
    label: 'Product Image',
    data: 'img',
    type: 'image',
    width: '15%',
  },
  {
    label: 'Internal Reference',
    data: 'reference',
    width: '20%',
  },
  {
    label: 'Name',
    data: 'name',
    width: '25%',
  },
  {
    label: 'Attribute Value',
    data: 'attribute_name',
    width: '20%',
  },
  // {
  //     label: "Unit Price",
  //     data: "price",
  //     type: "price",
  //     width: "15%"
  // },
  // {
  //     label: "",
  //     data: "",
  //     type: "action",
  //     action: [
  //         {
  //             icon: require('@assets/img/icons/cart.svg'),
  //             name: 'cart'
  //         }
  //     ],
  //     width: "5%"
  // }
];

function ProductCatalogScreen(props) {
  const dispatch = useDispatch();

  const tableRef = useRef();
  const [modalProduct, setModalProduct] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [fiteredList, setFilteredList] = useState([]);
  const [paramsTable, setParamsTable] = useState({
    filter: {
      'brand.id': props?.route?.params?.id || '',
    },
    limit: isWeb ? 10 : 15,
    skip: 0,
  });

  const getAttibute = (attr) => {
    const result = [];
    for (const [key, value] of Object.entries(attr)) {
      if (key == 'size') {
        result.push('Size : ' + value.name);
      } else if (key == 'shade') {
        result.push('Shade : ' + value.name);
      } else if (key == 'variant') {
        result.push('Variant : ' + value.name);
      } else if (key == 'non_specify') {
        result.push(value.name);
      }
    }
    return result.join(', ');
  };

  const products = tableApi(
    MsCatalog.getProductCount,
    MsCatalog.getProducts,
    getProductsCountFromEs,
    getProductsFromEs,
  );

  const onSearchTable = async (param, type) => {
    const params = { ...paramsTable };
    if (type === 'keyword') {
      if (param.keyword.length > 2) {
        params.filter['keyword'] = param.keyword;
      } else if (!param.keyword) {
        delete params.filter['keyword'];
      }
    } else if (type === 'pagination') {
      setLoadingMore(true);
      params.limit = param.limit;
      params.skip = param.skip;
    }
    await setParamsTable({ ...params });
    doSearch(params);
  };

  const generateData = (data) => {
    if (!data?.length) {
      return [];
    }
    return data.map((item) => {
      const img = (item.images || []).filter((x) => x.is_cover);
      const defCombi = item?.default_combination?._id
        ? item.default_combination
        : item.combinations && item.combinations.length
        ? item.combinations[0]
        : null;
      return {
        attribute_name:
          defCombi && defCombi.reference
            ? getAttibute(defCombi.attributes)
            : '',
        combinations: item.combinations || [],
        default_combination: item.default_combination || {},
        images: item.images || [],
        reference:
          defCombi && defCombi.reference ? '[' + defCombi.reference + ']' : '',
        img: img && img.length ? img[0].url : '',
        combination_id: (defCombi && defCombi._id) || '',
        itemice: (defCombi && defCombi.itemice) || 0,
        id: item.id,
        brand: item.brand,
        description: item.description || '',
        how_to_use: item.how_to_use || '',
        ingredients: item.ingredients || '',
        name: item.name,
        _id: item._id,
      };
    });
  };

  const doSearch = async (param = '') => {
    try {
      const params = param ? param : { ...paramsTable };
      if (!props?.route?.params?.id) {
        delete params.filter['brand.id'];
      }
      const hasFilter = params?.filter?.keyword ? true : false;
      products.request(params, null, hasFilter).then((response) => {
        if (response) {
          if (params.skip > 0 && !isWeb) {
            setFilteredList([...fiteredList, ...generateData(response)]);
          } else {
            setFilteredList(generateData(response));
          }
          setLoadingMore(false);
        }
      });
    } catch (e) {
      setLoadingMore(false);
    }
  };

  const onReload = () => {
    products.reset();
    setFilteredList([]);
    dispatch(paramsReseted());
  };

  useEffect(() => {
    props.navigation.addListener('focus', () => {
      dispatch(paramsReseted());
      doSearch();
    });
    props.navigation.addListener('blur', () => {
      onReload();
    });
  }, []);

  const callBackAction = ({ name, data, index }) => {
    console.log(name);
    console.log(data);
    console.log(index);
  };

  const callBackRowPress = ({ item, index }) => {
    setModalProduct(true);
    dispatch(setProductData(item));
  };

  const onCloseDetail = () => {
    setModalProduct(false);
    dispatch(setProductData({}));
  };

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => callBackRowPress({ item, index })}
      key={'list-brand-' + index}
      style={styles.tableRow}>
      <Image
        style={{ width: 36, height: 36 }}
        width={36}
        height={36}
        source={{ uri: item.img }}
      />
      <View style={{ marginLeft: 12 }}>
        <SociollaText
          type="medium"
          style={{ fontSize: 12, color: Colors.black1, marginBottom: 8 }}>
          {item.name}
        </SociollaText>
        <SociollaText style={{ fontSize: 14, color: Colors.black5 }}>
          {item.reference}
        </SociollaText>
        {/* <SociollaText style={{fontSize: 14,color:Colors.black1}} currency={true}>{item.price}</SociollaText> */}
      </View>
    </TouchableOpacity>
  );

  return (
    <MenuScreen>
      <ModalDetailProduct show={modalProduct} onClose={() => onCloseDetail()} />
      {isWeb && (
        <TouchableOpacity
          style={backSection}
          activeOpacity={0.6}
          onPress={() => props.navigation.navigate('BrandCatalogScreen')}>
          <Image
            style={{ width: 7, height: 12, marginRight: 15 }}
            width={7}
            height={12}
            svg={true}
            source={require('@assets/img/icons/arrow-left-grey.svg')}
          />
          <SociollaText style={backSectionText}>
            Back to product catalog
          </SociollaText>
        </TouchableOpacity>
      )}
      {isWeb && (
        <SociollaText
          type="medium"
          color="#171D29"
          style={{ marginBottom: 40, fontSize: 24 }}>
          {props.route.params.name}
        </SociollaText>
      )}
      {isWeb ? (
        <SociollaTable
          table={HEADER_DEKSTOP}
          datas={fiteredList}
          count={products.count}
          ref={tableRef}
          loading={products.loading}
          stickyHeaderIndices={[0]}
          showSearch={true}
          showPagination={true}
          searchPlaceholder={'Search by Name/SKU...'}
          onSearchTable={(val, type) => onSearchTable(val, type)}
          localParams={paramsTable}
          callBackAction={callBackAction}
          callBackRowPress={callBackRowPress}
        />
      ) : (
        <SociollaTable
          table={HEADER}
          datas={fiteredList}
          count={products.count}
          itemComponent={renderItem}
          headerComponent={<></>}
          loading={products.loading}
          loadingLoadMore={loadingMore}
          ref={tableRef}
          showSearch={true}
          scrollItem={true}
          searchPlaceholder={'Search by Name/SKU...'}
          onSearchTable={(val, type) => onSearchTable(val, type)}
          localParams={paramsTable}
          callBackAction={callBackAction}
          callBackRowPress={callBackRowPress}
        />
      )}
    </MenuScreen>
  );
}

const styles = StyleSheet.create({
  tableRow: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    height: 90,
    width: '100%',
    borderBottomColor: Colors.grey9,
    borderBottomWidth: 1,
    paddingLeft: 20,
  },
});

export default ProductCatalogScreen;
